<script>
export default {
  props: {
    width: {
      type: [Number, String],
      default: 200,
      required: false,
    },
    height: {
      type: [Number, String],
      default: 60,
      required: false,
    },
    bgColor: {
      type: String,
      default: "#ededed",
      required: false,
    },
    as: {
      type: String,
      default: "div",
      required: false,
    },
  },
  computed: {
    widthComputed() {
      return typeof this.width === "number" ? this.width + "px" : this.width;
    },
    heightComputed() {
      return typeof this.height === "number" ? this.height + "px" : this.height;
    },
  },
};
</script>

<template>
  <component
    :is="as"
    class="header-menu-item-placeholder"
    :style="{
      width: widthComputed,
      height: heightComputed,
      '--sk-bg-color': bgColor,
    }"
  />
</template>

<style scoped lang="scss">
.header-menu-item-placeholder {
  border-radius: 6px;
  background-color: var(--sk-bg-color);
  background: linear-gradient(
      100deg,
      rgba(255, 255, 255, 0) 40%,
      rgba(255, 255, 255, 0.5) 50%,
      rgba(255, 255, 255, 0) 60%
    )
    var(--sk-bg-color);
  background-size: 200% 100%;
  background-position-x: 180%;
  animation: 1s loading ease-in-out infinite;
}

@keyframes loading {
  to {
    background-position-x: -20%;
  }
}
</style>
